// Profil-Nachbau F-07, F-08 (output/profil-team-20261014/BAU-COCKPIT.md 1): alle Wortlaute des KI-Cockpits an einer Stelle.
// Abweichend vom Bauplan nach dem Wörtertest (frontend/tests/geldwoerter.test.mjs W1-G09, W1-G11): „österreichische Zeit“
// statt „österreichischer Zeit“ und der Exportknopf „Als Tabelle herunterladen (für Excel)“ statt „Als CSV …“.
import { GELD } from '../billing/geldWoerter';
import { MENUE, NICHT_LESBAR } from '../../config/ebenen';
import type { ErklaerInhalt } from '../../components/Erklaerung';

// Das Wort steht einmal in config/ebenen.ts (VE-13, PF-101).
export const TITEL = MENUE.kiCockpit;
/** Name der Reiterleiste für Vorlesehilfen. */
export const REITER_NAME = 'Teile des KI-Cockpits';
/** Suche in der Leiste des Firmen-Cockpits (PF-506); der Rahmen filtert die Titel der Teile. */
export const SUCHE = { label: `${MENUE.kiCockpit} durchsuchen`, platzhalter: 'Suchen', leer: 'Kein Teil des KI-Cockpits passt.' } as const;

// F-23 (PF-NB-cockpit-1, Betreiber H-02, H-08): der Kopf des Firmen-Cockpits nennt die Firma (ohne Firmennamen der bisherige
// Satz); das Plattform-Cockpit sagt „Alle Kundenfirmen“ und nennt den Weg in eine Firma so, wie er in der Verwaltung heißt.
// F-24: der Weg in eine Firma steht im Fenster WEGE.firmaSehen.
export const KOPF = {
  // F-24 (SPEC-cockpit 3.2, U1): kurze Unterzeile mit dem Firmennamen (F-23 bleibt), ohne festen Produktnamen.
  firma: (firma: string) => `Nutzung von ${firma} im gewählten Zeitraum`,
  firmaOhneName: 'Nutzung Ihrer Firma im gewählten Zeitraum',
  /** PF-SL5-cockpit-1 (Vergleich B7): auf „Aufmerksamkeit“ (ohne Zeitraumwahl) der Stand heute. */
  firmaStand: (firma: string) => `Nutzung von ${firma}, Stand heute`,
  firmaOhneNameStand: 'Nutzung Ihrer Firma, Stand heute',
  plattform: 'Alle Kundenfirmen: Nutzung, KI-Kosten, Umsatz und Marge',
} as const;

/** F-23 (PF-NB-cockpit-1): Wege zwischen Firmen-Cockpit, Plattform-Cockpit und den Kostenseiten. */
export const WEGE = {
  // F-24 (SPEC-cockpit 3.2, W1): ein fester Satz vor dem Link; die Firma nennt schon die Unterzeile des Kopfs.
  firmaHinweis: 'Nutzung, KI-Kosten und Umsatz aller Kundenfirmen:',
  zurPlattform: 'KI-Cockpit der Plattform öffnen',
  // F-24 (SPEC-cockpit 3.3, F-S): Fenster rechts im Kopf des Plattform-Cockpits; der Satz stand bisher in KOPF.plattform.
  firmaSehen: {
    frage: 'Wie sehe ich eine einzelne Firma?',
    teile: [
      { titel: '1. Nur Firmen', text: 'Hier stehen Firmen, nie Personen.' },
      { titel: '2. Sicht starten', text: 'In eine Firma schauen Sie über „Sicht starten …“ auf ihrer Seite unter „Firmen“.' },
    ],
  } as ErklaerInhalt,
} as const;

export const TEILE = {
  uebersicht: 'Übersicht', verlauf: 'Verlauf', personen: 'Nutzung je Person', teams: 'Nutzung je Team', firmen: 'Nutzung je Firma',
  tarife: 'Nutzung je Tarif', quellen: 'Quellen', aufmerksamkeit: 'Aufmerksamkeit', export: 'Export',
} as const;
export type Teil = keyof typeof TEILE;

// Profil-Nachbau F-25 (PF-GR-cockpit-2, SPEC cockpit-grafiken 2.3): Knopf mit Kalender wie meinGPT statt Auswahlliste; „Eigener
// Zeitraum“ und „Anzeigen“ entfallen, dazu „Letzte 14 Tage“. Die drei Fehlersätze sind die des Servers (cockpit/zeitraum.ts).
export const ZEITRAUM = {
  feld: 'Zeitraum', werkzeuge: 'Zeitraum und Filter', von: 'Von', bis: 'Bis', platzhalter: 'TT.MM.JJJJ',
  vorgaben: { 'heute': 'Heute', 'letzte-7-tage': 'Letzte 7 Tage', 'letzte-14-tage': 'Letzte 14 Tage', 'letzte-30-tage': 'Letzte 30 Tage',
    'dieser-monat': 'Dieser Monat', 'letzter-monat': 'Letzter Monat', 'dieses-jahr': 'Dieses Jahr' },
  format: 'Bitte das Datum als TT.MM.JJJJ eingeben, zum Beispiel 01.10.2026.',
  reihenfolge: 'Das Ende liegt vor dem Anfang.',
  laenge: 'Bitte höchstens 366 Tage bis heute wählen.',
  angezeigt: (von: string, bis: string, tage: number) => `Angezeigt: ${von} bis ${bis} · ${tage} ${tage === 1 ? 'Tag' : 'Tage'} · österreichische Zeit`,
  /** Name des Knopfs bei eigenem Zeitraum: „01.10.2026 – 14.10.2026“. */
  spanne: (von: string, bis: string) => `${von} – ${bis}`,
  dialog: 'Zeitraum wählen', vorgabenListe: 'Vorgaben', vorheriger: 'Vorheriger Monat', naechster: 'Nächster Monat',
  abbrechen: 'Abbrechen', anwenden: 'Anwenden', endeWaehlen: 'Jetzt das Ende wählen',
  tage: (n: number) => `${n} ${n === 1 ? 'Tag' : 'Tage'}`,
  beginn: 'Beginn', ende: 'Ende', heute: 'heute',
  wochentage: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
  wochentageLang: ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'],
  monate: ['Jänner', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
} as const;

export const KENNZAHL = {
  aktiveFirmen: 'Aktive Firmen', aktivePersonen: 'Aktive Personen', recherchen: 'Recherchen', nachfragen: 'Nachfragen',
  jeTag: 'Recherchen je Tag', zeit: 'Gewonnene Zeit', kosten: 'KI-Kosten', umsatz: 'Umsatz', marge: 'Marge', kontingent: GELD.verwendet,
  /** Name der Kennzahlenleiste für Vorlesehilfen. */
  leiste: 'Kennzahlen im Zeitraum',
  // F-23 (PF-NB-cockpit-2, Betreiber H-24): in der Einzahl „von 1 Firma“, „von 1 Person“.
  vonFirmen: (n: number, p: string) => `von ${n} ${n === 1 ? 'Firma' : 'Firmen'} mit Zugang (${p})`,
  inAllen: 'in allen Firmen',
  vonPersonen: (n: number, p: string) => `von ${n} ${n === 1 ? 'Person' : 'Personen'} Ihrer Firma (${p})`,
  frueher: (n: number) => `und ${n} ${n === 1 ? 'früheres Konto' : 'frühere Konten'}`,
  imZeitraum: 'im Zeitraum', inLaufenden: 'in laufenden Recherchen', imSchnitt: 'im Schnitt',
  geschaetzt: 'geschätzt', geschaetztAlle: 'geschätzt, alle Firmen',
  unbewertet: (n: number) => `davon ${n} ${n === 1 ? 'Aufruf' : 'Aufrufe'} noch nicht bewertet`,
  umsatzZusatz: 'aus Rechnungen, anteilig im Zeitraum',
  margeZusatz: (p: string) => `${p} vom Umsatz`,
  kontingentZusatz: 'im Zeitraum, Kontingent anteilig je Tag',
  keinKontingent: 'Für Ihre Firma ist kein Kontingent festgelegt.',
  regelAendern: 'Regel unter „Vorgaben für alle Firmen“ ändern',
  monatsStand: 'Den Stand dieses Monats sehen Sie unter „Kontingent“.',
} as const;

export const SO_RECHNET = {
  // Der Satz zur Regel steht auch unter „Vorgaben für alle Firmen“ › „Recherche und Kontingent“ (vorgaben/RechercheUndKontingent.tsx).
  zeit: (mR: number, mN: number) => `Gewonnene Zeit: ${mR} Minuten je Recherche${mN > 0 ? ` und ${mN} Minuten je Nachfrage` : '; Nachfragen zählen nicht'}, nur für Fragen mit Antwort.`,
  // F-24 (SPEC-cockpit 3.1): die Regeln als Tooltip an der Kachel, zu der sie gehören (F-07), gekürzt aus den Sätzen des früheren
  // Aufklappers „So rechnet CLAiRIS“; dessen Schlüssel titel, fragen, firmen, umsatz, zeitzone, zeitFirma, zeitPlattform und
  // kontingent entfallen mit PF-TX-cockpit-2 (E-3). firmenTipp nennt, wer als „Firma mit Zugang“ zählt (cockpit/plattform.ts MIT_ZUGANG).
  aktivTipp: 'Aktiv ist, wer im Zeitraum mindestens eine Frage gestellt hat.',
  rechercheTipp: 'Jede Frage, die eine neue Recherche beginnt.',
  nachfrageTipp: 'Jede weitere Frage in derselben Recherche ist eine Nachfrage.',
  zeitTippFirma: (mR: number, mN: number) => `Geschätzt: ${mR} Minuten Arbeit ohne KI je Recherche${mN > 0 ? ` und ${mN} je Nachfrage` : '; Nachfragen zählen nicht'}, nur Fragen mit Antwort. Ein Erfahrungswert des Anbieters.`,
  kontingentTipp: 'Verbrauch im Zeitraum im Verhältnis zum Kontingent dieser Tage, also Monatskontingent geteilt durch die Tage des Monats.',
  // B1-P2-9 (M-01): das Kontingent eines Pakets zählt Recherchen; jede Frage zählt wie bei der Sperre.
  kontingentTippRecherchen: 'Recherchen und Nachfragen im Zeitraum im Verhältnis zum Kontingent dieser Tage, also Monatskontingent in Recherchen geteilt durch die Tage des Monats. Jede Frage zählt. Hier fehlen Recherchen, die enden, bevor die KI zu arbeiten beginnt; beim Kontingent zählen sie mit.',
  firmenTipp: 'Aktiv mit mindestens einer Frage im Zeitraum. Mit Zugang: Kundenfirmen und Einzelkonten mit Status Aktiv, Testphase oder Zahlung überfällig, ohne interne Organisation.',
  zeitTippPlattform: (mR: number, mN: number) => `Geschätzt: ${mR} Minuten Arbeit ohne KI je Recherche${mN > 0 ? ` und ${mN} je Nachfrage` : '; Nachfragen zählen nicht'}, nur Fragen mit Antwort. Ein Erfahrungswert, keine Messung.`,
  umsatzTipp: 'Bezahlte Rechnungen ohne Testmodus, netto, nach ihrem Leistungszeitraum anteilig auf die Tage verteilt.',
  margeTipp: 'Umsatz minus KI-Kosten.',
} as const;

export const VERLAUF = {
  fragen: 'Recherchen und Nachfragen', personen: 'Aktive Personen', firmen: 'Aktive Firmen', kosten: 'KI-Kosten',
  tabelle: 'Werte als Tabelle', spalteZeitraum: 'Zeitraum', legende: ['Recherchen', 'Nachfragen'] as const,
  spalteKosten: 'KI-Kosten (netto)',
  /** Größe im Titel einer Säule: „01.10.2026: 3 aktive Firmen“. */
  anzahlFirmen: (n: string) => `${n} aktive Firmen`, anzahlPersonen: (n: string) => `${n} aktive Personen`,
  anzahlFragen: (recherchen: string, nachfragen: string) => `${recherchen} Recherchen, ${nachfragen} Nachfragen`,
} as const;

/** Profil-Nachbau F-25 (SPEC 2.1, PF-GR-cockpit-1): Wörter des Bausteins Diagramm (Diagramm.tsx). */
export const DIAGRAMM = {
  rolle: 'Diagramm',
  tasten: 'Pfeiltasten wählen den Abschnitt.',
  legende: 'Im Diagramm zeigen',
  zusammen: 'Zusammen',
  heute: ' (heute, bis jetzt)',
  bisHeute: ' (bis heute)',
  wochenende: 'Wochenende',
  eineBleibt: 'Eine Reihe bleibt immer sichtbar.',
  /** „Recherchen je Tag, 20.09. bis 19.10.2026: höchstens 14 am 07.10., zusammen 128.“ */
  satz: (name: string, zeitraum: string, hoechst: string, wann: string, zusammen: string) => `${name}, ${zeitraum}: höchstens ${hoechst} ${wann}, zusammen ${zusammen}.`,
  amTag: (tag: string) => `am ${tag}`, inWoche: (tag: string) => `in der Woche ab ${tag}`, imMonat: (monat: string) => `im ${monat}`,
  wochentageKurz: ['Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.', 'So.'] as const,
  monateKurz: ['Jän.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'] as const,
  // F-25 Entwurf C (PF-GC-baustein-2): Linienlegende und Ziellinie der Zielkurve.
  zeitraum: 'Zeitraum', vorzeitraum: 'Vorzeitraum', hochrechnung: 'Hochrechnung', ziel: 'Ziel',
  zielWert: (wert: string) => `Ziel ${wert}`,
  zielJe: (wert: string, einheit: 'WOCHE' | 'MONAT') => `Ziel ${wert} je ${einheit === 'WOCHE' ? 'Woche' : 'Monat'}`,
} as const;

/** Profil-Nachbau F-25 (PF-GR-stil-1, Entwurf A): Wörter der Bausteine im Stil A (BerichtBausteine.tsx). */
export const STIL = {
  kurzGesagt: 'Kurz gesagt',
  zumVorzeitraum: ' zum Vorzeitraum',
  neu: 'neu, davor keine',
  davor: (wert: number) => `davor ${wert} %`,
  marken: { hinweis: 'Hinweis', ok: 'In Ordnung', info: 'Zur Info' },
} as const;

export const PERSONEN = {
  // F-23 (PF-NB-cockpit-2, Fehlersuche Nr. 17, 35): kurzer Titel der Zeile und eine Erklärung; wer Namen einschalten darf, liest,
  // wie es geht, alle anderen, wer es darf. F-24: die Erklärung der Kennungen steht im Tooltip an „Ohne Namen“, der Rundungssatz
  // an „Ganze Firma“.
  ohneNamenTitel: 'Ohne Namen', mitNamenTitel: 'Mit Namen',
  ohneNamen: 'Die Kennungen „Person A“, „Person B“ … werden bei jedem Aufruf neu vergeben und lassen keinen Schluss auf eine Person zu.',
  namenSelbst: 'Namen nur mit Betriebsvereinbarung oder Zustimmung der Personen.',
  namenBesitzer: 'Namen kann nur der Besitzer Ihrer Firma einschalten.',
  mitNamen: (grundlage: string, wer: string, am: string) => `Namen sind eingeschaltet. Grundlage: ${grundlage}, bestätigt von ${wer} am ${am}.`,
  zweck: 'Nur zur Planung von Plätzen und Kontingent, nicht zur Leistungs- oder Verhaltenskontrolle. Jeder Aufruf steht im Änderungsprotokoll.',
  zuWenige: (n: number) => `Ohne Namen erst ab ${n} Personen mit Anfragen im Zeitraum; die Summe steht unten.`,
  abgerundet: 'Die Anteile je Person sind abgerundet. Zusammen ergeben sie deshalb etwas weniger als die ganze Firma.',
  nochNicht: 'teilweise noch nicht eingerechnet',
  spalten: { person: 'Person', lizenzplatz: 'Lizenzplatz', recherchen: 'Recherchen', nachfragen: 'Nachfragen', tokens: 'Tokens', anteil: GELD.verwendet, zuletzt: 'Zuletzt aktiv' },
  ehemalige: 'Ehemalige und gelöschte Konten', ganzeFirma: 'Ganze Firma', nochNie: 'noch nie',
  /** PF-506: eine Firma ohne Person mit Zugang; mit Namen „Lizenzplatz“ je Person. */
  keine: 'Ihre Firma hat gerade keine Person mit Zugang.', lizenzplatzWert: (hat: boolean) => hat ? 'Ja' : 'Nein',
  grundlagen: { BETRIEBSVEREINBARUNG: 'Betriebsvereinbarung', ZUSTIMMUNG: 'Zustimmung der Personen' } as Record<string, string>,
  namenZeigen: 'Namen zeigen …', namenAusblenden: 'Namen ausblenden', namenZeigenKnopf: 'Namen zeigen',
  dialogTitel: 'Namen im KI-Cockpit zeigen?',
  dialogWarnung: 'Dann sehen alle, die das KI-Cockpit öffnen dürfen, Recherchen und Anteil je Person mit Namen. In Österreich braucht eine solche Auswertung über Beschäftigte in der Regel eine Betriebsvereinbarung oder die Zustimmung der betroffenen Personen.',
  grundlage: 'Grundlage (Pflicht)', bestaetigung: 'Ich bestätige, dass diese Grundlage für unsere Firma vorliegt.', passwort: 'Ihr Passwort (Pflicht)',
  abbrechen: 'Abbrechen', eingeschaltet: 'Namen sind eingeschaltet. Der Eintrag steht im Änderungsprotokoll.', ausgeblendet: 'Namen sind ausgeblendet.',
  esFehlt: { grundlage: 'Grundlage', bestaetigung: 'Bestätigung', passwort: 'Passwort' },
  // F-25 Entwurf C (PF-GC-seite-4, c-person.html; seiten-c.js:38-66, seiten.js:161-163): Tabelle „Je Person“ und Namen-Block.
  tabelleTitel: 'Je Person', tabelleUnterzeile: 'Sortiert nach Kennung bzw. Name, nie nach Nutzung',
  ohneKontingent: '„Vom Kontingent verwendet“ bleibt leer, weil für Ihre Firma kein Kontingent festgelegt ist.',
  namenKlein: 'Jeder Aufruf mit Namen steht im Änderungsprotokoll. „Wer mitmacht“ bleibt ohne Namen.',
  // F-25 (Nachtrag 16:24, AUFTRAG-PF-GC-person-1): Balken der verbrauchten Tokens über der Tabelle (TokenBalken.tsx) und Spalte „Tokens“.
  tokensTitel: 'Verbrauchte Tokens je Person', tokensUnterzeile: 'im gewählten Zeitraum, Eingabe und Ausgabe',
  tokensInfo: 'Ein Token ist ein Wortteil, den die KI liest oder schreibt. Mehr Tokens heißt längere Fragen, Quellen und Antworten.',
  tokensOhneAngabe: (n: number) => `ohne Angabe für ${n} ${n === 1 ? 'Lauf' : 'Läufe'}`,
  tokensMio: (wert: string) => `${wert} Mio.`,
} as const;

/** B1-P2-9 (M-01): Kopf der Spalte des Anteils, wenn das Kontingent der Firma ein Paket in Recherchen ist (kontingentInRecherchen). */
export const ANTEIL_RECHERCHEN = 'Vom Kontingent in Recherchen verwendet';

/** Teil 4 „Nutzung je Team“ (PF-509, SPEC-WELLE-B WB-23). Die Spalte des Anteils heißt wie bei den Personen „Vom Kontingent
 *  verwendet“: der Server rechnet sie mit dem Kontingent dieser Tage (F-08, Frage F-C1), nicht als Anteil an der Nutzung. */
export const TEAMS = {
  spalten: { team: 'Team', personenHeute: 'Personen (heute)', aktivePersonen: 'Aktive Personen', recherchen: 'Recherchen', anteil: GELD.verwendet },
  ohneTeam: 'Ohne eigenes Team', geloeschte: 'Gelöschte Teams', ganzeFirma: 'Ganze Firma',
  /** F-24 (SPEC-cockpit 3.2, T-GT): Tooltip hinter „Ganze Firma“ im Fuß der Teamtabelle statt eines Absatzes darunter. */
  info: 'Jede Recherche zählt für das Team, zu dem die Person beim Start gehörte. Die Zeilen ergeben zusammen genau die ganze Firma.',
  leer: 'Im gewählten Zeitraum gab es keine Recherchen.',
  // F-25 Entwurf C (PF-GC-seite-4, c-team.html; seiten-c.js:68-99): Aufteilung als Einheiten und Tabelle „Je Team“.
  aufteilungTitel: 'So ist Ihre Firma aufgeteilt', aufteilungUnterzeile: 'Personen heute',
  tabelleTitel: 'Je Team',
} as const;

export const FIRMEN = {
  suche: 'Firma suchen', suchen: 'Suchen', ordnung: 'Ordnen nach', ordnungen: { name: 'Name', recherchen: 'Recherchen', kosten: 'KI-Kosten', trend: 'Trend' },
  spalten: { firma: 'Firma', tarif: 'Tarif', plaetze: 'Plätze', kontingent: GELD.verwendet, kosten: 'KI-Kosten', recherchen: 'Recherchen',
    nachfragen: 'Nachfragen', aktivePersonen: 'Aktive Personen', trend: 'Trend' },
  plaetze: (belegt: number, gesamt: number | null) => gesamt === null ? `${belegt}` : `${belegt} von ${gesamt}`,
  /** B1-P2-9 (M-01): Anteil einer Firma mit Kontingent in Recherchen (Paket). */
  inRecherchen: (p: string) => `${p} der Recherchen`,
  alle: 'Alle Firmen', leer: 'Keine Firma gefunden.', neu: 'neu',
  // F-25 Entwurf C (PF-GC-seite-5, c-plattform-firmen.html; seiten-c.js:193-238): Ziel, Firmen als Einheiten, Liste „Jede Firma“.
  zielOhne: 'Das Ziel für aktive Firmen legen Sie in der Übersicht fest.',
  einheitenTitel: 'Firmen im Zeitraum', einheitenUnterzeile: 'Gefüllt: hat gefragt',
  listeTitel: 'Jede Firma: Stand und nächster Schritt',
  listeHinweis: 'Hier stehen Firmen, nie Personen.',
} as const;

export const TARIFE = {
  // PF-SL5-cockpit-1 (Vergleich B2): „netto“ steht im Kopf wie in der Übersichtstabelle, die Zellen zeigen nur den Betrag.
  spalten: { tarif: 'Tarif', firmen: 'Firmen', plaetze: 'Plätze belegt', aktivePersonen: 'Aktive Personen', recherchen: 'Recherchen', nachfragen: 'Nachfragen',
    jePlatz: 'Recherchen je Platz', kosten: 'KI-Kosten (netto)', umsatz: 'Umsatz (netto)', marge: 'Marge (netto)' },
  firmen: (aktiv: number, n: number) => `${aktiv} von ${n} aktiv`,
  leer: 'Noch keine Firma in einem Tarif.',
  // F-25 Entwurf C (PF-GC-seite-5, c-plattform-tarife.html; seiten-c.js:240-258): Frage über den Tarifen; „Alle Tarife“ ist PLATTFORM_C.alleTarife.
  frage: 'Je Tarif: Wie viel der KI-Kosten deckt der Umsatz, und wie stark werden die Plätze genutzt?',
  frageOhneGeld: 'Je Tarif: Wie stark werden die Plätze genutzt?',
} as const;

export const QUELLEN = {
  spalten: { quelle: 'Quelle', antworten: 'Antworten mit Treffern daraus', anteil: 'Anteil der Antworten' },
  ohneTreffer: 'Ohne Treffer', ohneTrefferZusatz: (p: string) => `${p} der Antworten nannten keine Quelle`,
  // F-24 (SPEC-cockpit 3.2, Q-G): kürzer, für beide Cockpits; „Was gesucht wurde, steht hier nie.“ bleibt sichtbar (Pflichthinweis).
  grundlage: (n: number, m: number) => `Quellen aus den gespeicherten Antworten (${n} von ${m} Anfragen). Was gesucht wurde, steht hier nie.`,
  keineQualitaet: 'Die Antwortqualität sieht, wer den Betriebsstatus ansehen darf.',
} as const;

export const AUFMERKSAMKEIT = {
  stand: 'Stand heute, unabhängig vom Zeitraum.',
  kontingent: 'Kontingent bald aufgebraucht', inaktiv: 'Seit 30 Tagen nicht aktiv', zahlung: 'Zahlung überfällig', testphase: 'Testphase endet',
  kontingentGrund: (p: string, monat: string) => `${p} vom Kontingent im ${monat}`,
  zuletzt: (tag: string) => `zuletzt aktiv am ${tag}`, nochNie: 'noch nie aktiv',
  seit: (tag: string) => `überfällig seit ${tag}`, endet: (tag: string) => `endet am ${tag}`,
  /** F-23 (PF-NB-cockpit-2, Betreiber H-03 Teil): hinter „überfällig seit …“, wenn die Firma keinen Vertrag hat. */
  ohneVertrag: 'kein Vertrag hinterlegt',
  abwanderung: 'Abwanderungsgefahr: Diese Firmen zahlen, nutzen CLAiRIS aber nicht.',
  keineFirma: 'Keine Firma.', spalten: { firma: 'Firma', grund: 'Grund' },
  personenInaktiv: (n: number) => `${n} ${n === 1 ? 'Person Ihrer Firma hat' : 'Personen Ihrer Firma haben'} seit 30 Tagen keine Frage gestellt.`,
  mitgliederAnsehen: 'Mitglieder ansehen',
  firmaKontingent: (p: string, monat: string, inRecherchen?: boolean) =>
    `Ihre Firma hat ${p} des Kontingents${inRecherchen ? ' in Recherchen' : ''} im ${monat} verwendet.${inRecherchen ? ' Gezählt wird jede gestartete Recherche, auch eine, die endet, bevor die KI zu arbeiten beginnt.' : ''}`,
  grenze: (n: number) => `${n} ${n === 1 ? 'Person hat' : 'Personen haben'} mindestens 80 % ihrer persönlichen Grenze erreicht.`,
  /** Mit Namen: Spalte der Personen ab 80 % ihrer Grenze. */
  spalteGrenze: GELD.persoenlicheGrenze,
  nichts: 'Gerade braucht nichts Ihre Aufmerksamkeit.',
  // F-25 Entwurf C (PF-GC-seite-4, c-aufmerksamkeit.html; seiten-c.js:126-138): die Prüfungen der Firma als Statusliste.
  pruefungenTitel: (n: number) => n === 3 ? 'Die drei Prüfungen' : n === 2 ? 'Die zwei Prüfungen' : 'Die Prüfung',
  inaktivOk: 'Niemand ist seit 30 Tagen ohne Frage.',
  grenzenTitel: 'Persönliche Grenzen', grenzeOk: 'Niemand bei 80 % der persönlichen Grenze.',
  kontingentTitel: 'Kontingent',
  kontingentKein: 'Kein Kontingent festgelegt; zählt als in Ordnung.',
  kontingentOk: 'Ihre Firma liegt in diesem Monat unter 80 % des Kontingents.',
  kontingentOkRecherchen: 'Ihre Firma liegt in diesem Monat unter 80 % des Kontingents in Recherchen.',
  // F-25 Entwurf C (PF-GC-seite-5, c-plattform-aufmerksamkeit.html; seiten-c.js:268-284): Block der vier Prüfungen aller Firmen.
  pruefungenPlattform: 'Die vier Prüfungen',
} as const;

export const EXPORT = {
  knopf: GELD.tabelleHerunterladen, herunterladen: 'Herunterladen', abbrechen: 'Abbrechen', passwort: 'Ihr Passwort (Pflicht)',
  fertig: 'Der Export wurde heruntergeladen.',
  firma: {
    verlauf: 'Recherchen, Nachfragen und aktive Personen je Tag', personen: 'Recherchen, Nachfragen und Anteil je Person',
    teams: 'Recherchen und Anteil je Team', quellen: 'Quellen der Antworten',
  } as Record<string, string>,
  /** BAU-COCKPIT 1.3 Nr. 7: die Inhalte der Firma, je Zeile und im Titel des Dialogs; „teams“ nur mit Teams (PF-509, WB-24). */
  firmaTitel: { verlauf: 'Verlauf je Tag', personen: TEILE.personen, teams: TEILE.teams, quellen: TEILE.quellen } as Record<string, string>,
  plattform: {
    verlauf: 'Verlauf je Tag', firmen: 'Nutzung je Firma', tarife: 'Nutzung je Tarif', quellen: 'Quellen der Antworten',
  } as Record<string, string>,
  titel: (inhalt: string) => `${inhalt} als Tabelle herunterladen`,
  satzFirma: (inhalt: string, von: string, bis: string, ohneAnzahlen = false) => `Die Datei enthält ${inhalt} für ${von} bis ${bis}, nur ${ohneAnzahlen ? '' : 'Anzahlen und '}Prozent, ohne Beträge. Der Download wird im Änderungsprotokoll vermerkt.`,
  // F-24 (SPEC-cockpit 3.3, E-P): einmal über den Zeilen statt in jeder Zeile.
  satzPlattform: (von: string, bis: string) => `Für ${von} bis ${bis}, Beträge netto in Euro. Jeder Export steht im Betreiberprotokoll.`,
  ohneRecht: 'Den Export mit Beträgen darf, wer den Kostenbericht ausleiten darf.',
  // F-25 Entwurf C (PF-GC-seite-4, c-export.html; seiten-c.js:140-168): Vorschau der gewählten Datei (auch die Plattform, PF-GC-seite-5).
  vorschauTitel: 'Vorschau der gewählten Datei',
  vorschauLabel: (titel: string) => `Vorschau: ${titel}`,
  vorschauProtokoll: 'Auch diese Vorschau steht im Änderungsprotokoll.',
  // F-25 Entwurf C (PF-GC-seite-5, c-plattform-export.html): Unterzeile der Schrittfolge und Spalte der Vorschau; „Umsatz (netto)“ ist
  // PLATTFORM_C.spalteUmsatz.
  folgeUnterzeilePlattform: 'Beträge netto; jeder Export steht im Betreiberprotokoll',
  spalteMarge: 'Marge (netto)',
} as const;

/** F-25 (PF-GR-saetze-2; Entwurf A, seiten.js): die Sätze der übrigen Teile. berichtTeile.ts setzt sie nach festen Regeln zusammen;
 *  Teile mit führendem Leerzeichen folgen einem Satzteil davor. Kein Betrag: Euro-Texte der Plattform kommen fertig herein. */
export const BERICHT_TEILE = {
  stand: (datum: string, uhrzeit: string) => `Stand heute, ${datum}, ${uhrzeit} Uhr, unabhängig vom Zeitraum`,
  dateiVorschau: (n?: number) => n === undefined ? 'So sieht die Datei aus' : `So sieht die Datei aus (${n} ${n === 1 ? 'Zeile' : 'Zeilen'})`,
  personen: (n: number) => `${n} ${n === 1 ? 'Person' : 'Personen'}`,
  person: {
    niemandHeute: 'Heute hat noch niemand eine Frage gestellt.',
    niemand: (zeit: string) => `${zeit} hat niemand gefragt.`,
    vor: (zeit: string, einzahl: boolean) => `${zeit} ${einzahl ? 'hat' : 'haben'} `,
    von: (aktiv: number, alle: number) => `${aktiv} von ${alle} ${alle === 1 ? 'Person' : 'Personen'}`,
    alle: (n: number) => `alle ${n} Personen`,
    einzige: 'die einzige Person Ihrer Firma',
    nach: (produkt: string) => ` ${produkt} genutzt.`,
    breit: 'Die Nutzung ist breit verteilt: Keine Person stellt mehr als ein Viertel der Recherchen.',
    eine: (p: number) => `Eine Person stellt etwa ${p} % der Recherchen.`,
    stufeVor: (k: number) => ` ${k} Personen fragten `,
    mal: (von: number, bis: number | null) => von === bis ? `${von}-mal` : bis === null ? `${von}-mal oder öfter` : `${von}–${bis}-mal`,
    ohneRecherche: (k: number, nichts: boolean) => ` ${k === 1 ? 'hat' : 'haben'} im Zeitraum ${nichts ? 'nichts gefragt.' : 'keine neue Recherche begonnen.'}`,
    keineRecherchen: 'Im Zeitraum gab es keine Recherchen.',
    zuWenige: (produkt: string, n: number) => `Ohne Namen zeigt ${produkt} Zahlen je Person erst ab ${n} Personen mit Anfragen im Zeitraum; unten steht die Summe der ganzen Firma.`,
    grafik: 'Jede Säule zählt Personen. Wer in welcher Säule steht, zeigt die Grafik nie.',
    grafikZuWenige: (n: number) => `Die Verteilung erscheint ab ${n} aktiven Personen.`,
    stufeName: (text: string) => `${text} Recherchen`,
  },
  team: {
    einTeam: (name: string, n: number) => `Ihre Firma hat ein Team: „${name}“ mit ${n} ${n === 1 ? 'Person' : 'Personen'}.`,
    mehrTeams: (k: number, n: number) => `Ihre Firma hat ${k} Teams mit zusammen ${n} ${n === 1 ? 'Person' : 'Personen'}.`,
    keinTeam: 'Ihre Firma hat gerade kein Team.',
    ohne: (m: number) => ` ${m} ${m === 1 ? 'Person gehört' : 'Personen gehören'} zu keinem Team.`,
    alleImTeam: ' Alle Personen gehören zu einem Team.',
    geloeschte: ' Recherchen gelöschter Teams stehen unten gesammelt.',
    schutzVor: (produkt: string, n: number) => `Zahlen je Team zeigt ${produkt} ohne Namen erst ab ${n} Personen mit Anfragen im Zeitraum. Deshalb sehen Sie hier nur die ganze Firma: `,
    schutzBezug: (aktiv: number, recherchen: number) => `${aktiv} aktive ${aktiv === 1 ? 'Person' : 'Personen'} und ${recherchen} ${recherchen === 1 ? 'Recherche' : 'Recherchen'}`,
    schutzTippKopf: 'Warum keine Teamzahlen?',
    schutzTipp: (n: number) => `Bei kleinen Gruppen ließe sich sonst erkennen, wer wie viel fragt. Mit eingeschalteten Namen oder ab ${n} aktiven Personen je Gruppe stehen hier Zahlen.`,
    groesste: (name: string, aktiv: number, p: number, schnitt: number | null) =>
      `${name} stellt mit ${aktiv} aktiven ${aktiv === 1 ? 'Person' : 'Personen'} ${p} % der Recherchen der Firma${schnitt === null ? '' : `, im Schnitt ${schnitt} je Person`}.`,
    verdeckt: (k: number) => ` ${k} ${k === 1 ? 'Gruppe bleibt' : 'Gruppen bleiben'} verdeckt, damit sich keine kleine Gruppe ausrechnen lässt.`,
    alleMitZahlen: (n: number) => ` Alle Gruppen haben mindestens ${n} aktive Personen, deshalb stehen überall Zahlen.`,
    mitNamen: ' Mit eingeschalteten Namen stehen überall Zahlen.',
    legendeTeam: (name: string, n: number) => `${name}: ${n}`,
    legendeImTeam: (n: number) => `In einem Team: ${n}`,
    legendeOhne: (n: number) => `Ohne eigenes Team: ${n}`,
    aufteilungLabel: (a: number, b: number) => `${a} ${a === 1 ? 'Person' : 'Personen'} in einem Team, ${b} ${b === 1 ? 'Person' : 'Personen'} ohne eigenes Team`,
    balkenText: (recherchen: string, p: number) => `${recherchen} (${p} %)`,
  },
  aufmerksamkeit: {
    eine: 'Gerade braucht nur eine Sache Ihre Aufmerksamkeit.',
    mehrere: (n: number) => `Gerade brauchen ${n} Dinge Ihre Aufmerksamkeit.`,
    inaktivNach: (n: number) => ` Ihrer Firma ${n === 1 ? 'hat' : 'haben'} seit 30 Tagen keine Frage gestellt.`,
    inaktivTippOhne: 'Ohne Namen sehen Sie nur die Anzahl. Mit eingeschalteten Namen stehen hier Name und letzter Tag.',
    inaktivTippMit: 'Name und letzter Tag stehen unten in der Liste.',
    rest: ' Alles andere ist in Ordnung.',
    pruefungen: (n: number) => `${n === 1 ? 'Eine Prüfung' : n === 2 ? 'Zwei Prüfungen' : n === 3 ? 'Drei Prüfungen' : 'Vier Prüfungen'}, jeden Tag neu`,
  },
  plattform: {
    keine: 'Gerade braucht keine Firma Ihre Aufmerksamkeit.',
    eineVor: 'Eine Firma braucht Aufmerksamkeit: ',
    grundZahlung: ' ist mit der Zahlung überfällig.',
    grundKontingent: (p: string, inRecherchen?: boolean) => ` hat ${p} des Kontingents${inRecherchen ? ' in Recherchen' : ''} in diesem Monat verwendet.`,
    grundInaktiv: ' hat seit 30 Tagen keine Frage gestellt.',
    grundTestphase: (tag: string) => ` beendet am ${tag} die Testphase.`,
    mehrere: (n: number) => `${n} Hinweise brauchen Ihre Aufmerksamkeit.`,
    seit: (tag: string | null, ohneVertrag: boolean) => `Überfällig ${tag === null ? 'seit unbekanntem Tag' : tag === 'heute' ? 'seit heute' : `seit ${tag}`}${ohneVertrag ? '; für die Firma ist kein Vertrag hinterlegt.' : '.'}`,
    anzahl: (titel: string, n: number) => `${titel}: ${n}`,
    unauffaellig: { zahlung: 'Zahlungen', kontingent: 'Kontingent', testphase: 'Testphasen', inaktiv: 'Inaktivität' } as Record<string, string>,
    istUnauffaellig: (teile: string[]) => teile.length === 1
      ? `${teile[0]} ${teile[0] === 'Zahlungen' || teile[0] === 'Testphasen' ? 'sind' : 'ist'} unauffällig.`
      : `${teile.slice(0, -1).join(', ')} und ${teile[teile.length - 1]} sind unauffällig.`,
    alleOk: 'Alle vier Prüfungen sind unauffällig.',
  },
  export: {
    firmaSatz: (von: string, bis: string) => `Hier laden Sie die Zahlen für ${von} bis ${bis} als Tabelle für Excel.`,
    firmaFolge: 'Die Dateien enthalten nur Anzahlen und Prozent, keine Beträge. Jeder Download braucht Ihr Passwort und steht im Änderungsprotokoll.',
    plattformFolge: 'Jeder Export steht im Betreiberprotokoll. Firmen sehen solche Dateien nie; sie bekommen nur Anzahlen und Prozent.',
  },
  firmen: {
    keineMitZugang: 'Noch keine Firma hat Zugang.',
    einzigeNicht: 'Im Zeitraum hat die einzige Firma mit Zugang nicht gefragt.',
    keine: (m: number) => `Im Zeitraum hat keine der ${m} Firmen mit Zugang gefragt.`,
    einzige: 'Die einzige Firma mit Zugang hat gefragt',
    alle: (m: number) => `Alle ${m} Firmen mit Zugang haben gefragt.`,
    nurEine: (m: number) => `Von ${m} Firmen mit Zugang hat nur 1 gefragt`,
    einige: (m: number, a: number) => `Von ${m} Firmen mit Zugang haben ${a} gefragt.`,
    mit: (r: string, einzahl: boolean) => ` mit ${r} ${einzahl ? 'Recherche' : 'Recherchen'}.`,
    topTipp: (r: string, n: string) => `${r} Recherchen und ${n} Nachfragen im Zeitraum.`,
    still: (k: number) => `${k} ${k === 1 ? 'Firma hat' : 'Firmen haben'} im Zeitraum nichts gefragt.`,
    ohneUmsatz: (kosten: string) => `Umsatz ist im Zeitraum keiner verbucht, die KI kostete ${kosten}.`,
    mitUmsatz: (kosten: string, umsatz: string) => `Die KI kostete ${kosten} bei ${umsatz} Umsatz.`,
  },
  tarife: {
    eineFirma: (name: string) => `Die einzige Firma ist im Tarif ${name}.`,
    alleFirmen: (n: number, name: string) => `Alle ${n} Firmen sind im Tarif ${name}.`,
    jePlatzVor: ' Je belegtem Platz gab es ',
    recherchen: (x: string) => `${x} Recherchen`,
    davor: (y: string) => `, davor ${y}.`,
    keinPlatz: ' In diesem Tarif ist kein Platz belegt.',
    tippKopf: 'Recherchen je Platz',
    tipp: (plaetze: number, davor: string | null) => `Recherchen im Zeitraum geteilt durch die belegten Plätze (${plaetze}).${davor === null ? '' : ` Davor: ${davor}.`}`,
    keinerBelegt: 'In keinem Tarif ist ein Platz belegt.',
    faktor: (a: string, f: string, b: string, x: string, y: string) => `Im Tarif ${a} wird je Platz ${f}-mal so viel gefragt wie im Tarif ${b}: ${x} statt ${y} Recherchen.`,
    spanne: (x: string, y: string) => `Je belegtem Platz gab es in den Tarifen zwischen ${x} und ${y} Recherchen.`,
    gleich: (x: string) => `Je belegtem Platz gab es ${x} Recherchen.`,
    ohneUmsatz: (kosten: string, marge: string) => `Die KI kostete im Tarif ${kosten}; ohne Umsatz bleibt die Marge bei ${marge}.`,
    mitUmsatz: (kosten: string, umsatz: string, marge: string) => `Die KI kostete im Tarif ${kosten}, der Umsatz lag bei ${umsatz}, die Marge bei ${marge}.`,
    alleTragen: (n: number, name: string, marge: string) => `Alle ${n} Tarife tragen sich; die beste Marge hat ${name} mit ${marge}.`,
    traegtNicht: (name: string, marge: string) => `${name} trägt sich nicht: Die Marge liegt bei ${marge}.`,
  },
} as const;

// BAU-COCKPIT.md 1.4 (Dialog an der Kennzahl) und 0.4 (derselbe Inhalt als Abschnitt unter „Vorgaben für alle Firmen“).
// „(Pflicht)“ hängt Field an die zwei Beschriftungen der Minuten (GB-02).
export const REGEL = {
  titel: 'Gewonnene Zeit im KI-Cockpit',
  dialogTitel: 'Regel für die gewonnene Zeit', knopf: 'Regel ändern …', laden: 'Die Regel wird geladen …', abbrechen: 'Abbrechen',
  beschreibung: 'So rechnet das KI-Cockpit der Firmen und der Plattform die gewonnene Zeit. Nur Fragen mit Antwort zählen.',
  sichtbar: 'Gewonnene Zeit im KI-Cockpit der Firmen zeigen',
  recherche: 'Minuten je Recherche', nachfrage: 'Minuten je Nachfrage', nachfrageHinweis: '0: Nachfragen zählen nicht.',
  warnung: 'Ab dem Speichern rechnen alle Firmen mit der neuen Regel; die Zahl ändert sich auch für frühere Zeiträume.',
  speichern: 'Regel speichern', gespeichert: 'Die Regel ist gespeichert. Sie gilt sofort für alle Firmen.',
  bereich: (min: number, max: number) => `Bitte eine ganze Zahl von ${min} bis ${max} eingeben.`,
  ohneRecht: 'Die Regel ändert, wer Systemeinstellungen ändern darf.',
} as const;

export const ALLGEMEIN = {
  laden: 'KI-Cockpit wird geladen …',
  leer: 'Im gewählten Zeitraum gab es keine Anfragen.',
  sicht: NICHT_LESBAR,
  /** F-21 Sollte 14 (PF-811-a): das Firmen-Cockpit in „Sicht wechseln“. */
  sichtLesend: 'Sie sehen das KI-Cockpit dieser Firma in der Sicht: ohne Namen und nur lesend.',
} as const;

// ---- Profil-Nachbau F-25 (PF-GR-saetze-1; cockpit-grafiken-20261019\SCHNITTSTELLEN.md 5.3, Entwurf A „Bericht in Sätzen“): die
// Wörter der Sätze auf der Übersicht beider Cockpits, im Teil „Quellen“, im Wochenrhythmus und in den Tooltips der Bezüge. bericht.ts
// wählt nach festen Regeln und setzt zusammen; hier steht jedes Wort. ⟦…⟧ markiert einen Bezug (Text, der mit Grafik oder Tooltip
// verbunden ist); bericht.ts entfernt die Marken. Nie ein Betrag (die Plattform gibt fertige Beträge über netMoney herein), nie eine
// Person, nie ein fester Produktname.
export const BERICHT = {
  zeit: {
    fest: { heute: 'Heute', 'letzte-7-tage': 'In den letzten 7 Tagen', 'letzte-14-tage': 'In den letzten 14 Tagen',
      'letzte-30-tage': 'In den letzten 30 Tagen' } as Record<string, string>,
    monat: (monat: string) => `Im ${monat}`,
    jahr: (jahr: string) => jahr,
    eigen: (von: string, bis: string) => `Vom ${von} bis ${bis}`,
    einTag: (tag: string) => `Am ${tag}`,
    /** Übrige Seiten und Plattform (Entwurf mittel\seiten.js zeitText): der laufende Monat mit „bisher“, das Jahr ab Jahresbeginn. */
    monatBisher: (monat: string) => `Im ${monat} bisher`,
    seitJahresbeginn: 'Seit Jahresbeginn',
    bisher: 'bisher ',
  },
  wer: {
    firma: { nominativ: 'Ihr Team', verb: 'hat', dativ: 'Ihrem Team' },
    team: (name: string) => ({ nominativ: `das Team „${name}“`, verb: 'hat', dativ: `dem Team „${name}“` }),
    ohneTeam: { nominativ: 'die Personen ohne eigenes Team', verb: 'haben', dativ: 'den Personen ohne eigenes Team' },
  },
  haupt: {
    rechtsfragen: (zahl: string, eine: boolean) => `${zahl} ${eine ? 'neue Rechtsfrage' : 'neue Rechtsfragen'}`,
    gestellt: (zeit: string, verb: string, wer: string, bisher: string, rechtsfragen: string, vergleich: string) =>
      `${zeit} ${verb} ${wer} ${bisher}⟦${rechtsfragen}⟧ gestellt${vergleich}.`,
    keine: (zeit: string, verb: string, wer: string, bisher: string) => `${zeit} ${verb} ${wer} ${bisher}keine neue Rechtsfrage gestellt.`,
    heuteKeine: (verb: string, wer: string) => `Heute ${verb} ${wer} noch keine neue Rechtsfrage gestellt.`,
  },
  vergleich: {
    tage: (tage: number) => `in den ${tage} Tagen davor`, tag: 'am Tag davor', gestern: 'gestern',
    mehr: (prozent: string, davor: string) => ` – ⟦${prozent} mehr⟧ als ${davor}`,
    weniger: (prozent: string, davor: string) => ` – ⟦${prozent} weniger⟧ als ${davor}`,
    gleich: (davor: string) => ` – ⟦genauso viele⟧ wie ${davor}`,
    keine: ', davor waren es keine', gesternKeine: ', gestern waren es keine',
    /** Ohne Bezug, für die übrigen Sätze (vergleichText; Entwurf mittel\seiten.js vergleichText). */
    textMehr: (prozent: string, davor: string) => `${prozent} mehr als ${davor}`,
    textWeniger: (prozent: string, davor: string) => `${prozent} weniger als ${davor}`,
    textGleich: 'genauso viele wie davor',
  },
  folge: {
    alle: (personen: string) => `Alle ${personen} Personen haben mitgemacht.`,
    einzige: 'Die einzige Person hat mitgemacht.',
    mitgemacht: (aktiv: string, eine: boolean, personen: string, einePerson: boolean) =>
      `⟦${aktiv} von ${personen} ${einePerson ? 'Person' : 'Personen'}⟧ ${eine ? 'hat' : 'haben'} mitgemacht.`,
    amTag: (tag: string, recherchen: string, eine: boolean) => `Am meisten los war am ⟦${tag}⟧ mit ${recherchen} ${eine ? 'Recherche' : 'Recherchen'}`,
    inWoche: (ab: string, recherchen: string, eine: boolean) => `Am meisten los war in der Woche ab ⟦${ab}⟧ mit ${recherchen} ${eine ? 'Recherche' : 'Recherchen'}`,
    imMonat: (monat: string, recherchen: string, eine: boolean) => `Am meisten los war im ⟦${monat}⟧ mit ${recherchen} ${eine ? 'Recherche' : 'Recherchen'}`,
    wochentag: (adverb: string, kaum: boolean) => `; ⟦${adverb}⟧ wird am meisten gefragt${kaum ? ', am Wochenende kaum' : ''}.`,
    nachfragen: (zahl: string, eine: boolean, trend: string | null) =>
      `Dazu ${eine ? 'kam' : 'kamen'} ${zahl} ${eine ? 'Nachfrage' : 'Nachfragen'}${trend ? ` (${trend})` : ''}.`,
    nurNachfragen: (zahl: string, eine: boolean) => `Es gab aber ${zahl} ${eine ? 'Nachfrage' : 'Nachfragen'} in laufenden Recherchen.`,
    gestern: (recherchen: string, eineRecherche: boolean, nachfragen: string, eineNachfrage: boolean, personen: string | null, einePerson: boolean) =>
      `Gestern waren es ${recherchen} ${eineRecherche ? 'Recherche' : 'Recherchen'} und ${nachfragen} ${eineNachfrage ? 'Nachfrage' : 'Nachfragen'}${personen === null ? '' : ` von ${personen} ${einePerson ? 'Person' : 'Personen'}`}.`,
    gesternKeine: 'Gestern gab es keine Anfragen.',
    zeit: (produkt: string, dativ: string, dauer: string, arbeitstage: string | null) =>
      `Geschätzt hat ${produkt} ${dativ} ⟦${dauer}⟧ Arbeit abgenommen${arbeitstage ? `, ${arbeitstage}` : ''}.`,
    arbeitstage: {
      genau: (zahl: string, einer: boolean) => `${zahl} ${einer ? 'Arbeitstag' : 'Arbeitstage'}`,
      gut: (zahl: string, einer: boolean) => `gut ${zahl} ${einer ? 'Arbeitstag' : 'Arbeitstage'}`,
      fast: (zahl: string) => `fast ${zahl} Arbeitstage`,
    },
  },
  wochentage: ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'],
  wochentageMehrzahl: ['Montagen', 'Dienstagen', 'Mittwochen', 'Donnerstagen', 'Freitagen', 'Samstagen', 'Sonntagen'],
  wochentageAdverb: ['montags', 'dienstags', 'mittwochs', 'donnerstags', 'freitags', 'samstags', 'sonntags'],
  wochentageAdverbGross: ['Montags', 'Dienstags', 'Mittwochs', 'Donnerstags', 'Freitags', 'Samstags', 'Sonntags'],
  /** „Dienstag, 13. Oktober“ (Monat aus format.ts monatName, mit „Jänner“). */
  tagSatz: (wochentag: string, tag: number, monat: string) => `${wochentag}, ${tag}. ${monat}`,
  rhythmus: {
    wort: { beide: 'Fragen', recherchen: 'Recherchen', nachfragen: 'Nachfragen' },
    zuKurz: 'Für einen Wochenrhythmus braucht es mindestens 7 abgeschlossene Tage.',
    kurz: (wort: string) => `Im kurzen Zeitraum zählt jeder Tag einzeln: ${wort} je Wochentag.`,
    spitze: (wochentag: string, schnitt: string, wort: string) => `${wochentag} wird am meisten gefragt: im Schnitt ${schnitt} ${wort}.`,
    nichts: 'Im Zeitraum wurde an keinem Wochentag gefragt.',
    zeile: (wochentag: string, schnitt: string, wort: string, tage: number) => `${wochentag}: im Schnitt ${schnitt} ${wort} an ${tage} ${tage === 1 ? 'Tag' : 'Tagen'}`,
    ohneTag: (wochentag: string) => `${wochentag}: im Zeitraum kein abgeschlossener Tag`,
  },
  plattform: {
    firmen: (aktiv: string, mitZugang: string, eineFirma: boolean) => `${aktiv} von ${mitZugang} ${eineFirma ? 'Firma' : 'Firmen'}`,
    recherchen: (zahl: string, eine: boolean) => `${zahl} ${eine ? 'Recherche' : 'Recherchen'}`,
    genutzt: (zeit: string, verb: string, firmen: string, produkt: string, recherchen: string | null) =>
      `${zeit} ${verb} ⟦${firmen}⟧ ${produkt} genutzt${recherchen ? `, mit ${recherchen}` : ''}.`,
    verb: { eine: 'hat', mehrere: 'haben' },
    keine: (zeit: string, mitZugang: string, produkt: string) => `${zeit} hat keine der ${mitZugang} Firmen ${produkt} genutzt.`,
    keineEine: (zeit: string, produkt: string) => `${zeit} hat die eine Firma ${produkt} nicht genutzt.`,
    keineFirma: (zeit: string, produkt: string) => `${zeit} hat keine Firma ${produkt} genutzt.`,
    heuteKeine: (produkt: string) => `Heute hat noch keine Firma ${produkt} genutzt.`,
    dasSind: (vergleich: string) => `Das sind ${vergleich}.`,
    davorKeine: 'Davor gab es keine.', gesternKeine: 'Gestern gab es keine.',
    kosten: (kosten: string, jeRecherche: string | null) => `Die KI hat dafür ⟦${kosten}⟧ gekostet${jeRecherche ? `, im Schnitt ${jeRecherche} je Recherche` : ''}.`,
    umsatzNull: (marge: string) => `Umsatz gab es im Zeitraum keinen, die Marge liegt deshalb bei ${marge}.`,
    umsatz: (umsatz: string, marge: string) => `Der Umsatz lag bei ${umsatz}, die Marge bei ${marge}.`,
    tarif: (name: string) => `Gefiltert: Tarif ${name}.`,
  },
  quellen: {
    keine: 'Im gewählten Zeitraum gab es keine Antworten mit Quellen.',
    keineQuelle: 'Keine Antwort nannte eine Quelle.',
    anteil: { alle: 'Alle Antworten stützen', fastAlle: 'Fast alle Antworten stützen', dreiVonVier: 'Drei von vier Antworten stützen',
      zweiVonDrei: 'Zwei von drei Antworten stützen', jedeZweite: 'Etwa jede zweite Antwort stützt', prozent: (prozent: string) => `${prozent} der Antworten stützen` },
    haupt: (anteil: string, quelle: string) => `${anteil} sich auf ⟦${quelle}⟧.`,
    /** Quellenarten, deren Name in der Mehrzahl steht („werden“). */
    mehrzahl: ['DOKUMENTE', 'RIS_SONSTIGE'] as readonly string[],
    wechsel: (quelle: string, mehrzahl: boolean, jetzt: string, davor: string) =>
      `⟦${quelle}⟧ ${mehrzahl ? 'werden' : 'wird'} deutlich öfter gebraucht als davor: ${jetzt} statt ${davor}.`,
    ohne: (zahl: string, eine: boolean, prozent: string, vergleich: string) =>
      `${zahl} ${eine ? 'Antwort' : 'Antworten'} (${prozent}) ${eine ? 'nannte' : 'nannten'} keine Quelle${vergleich}.`,
    ohneWeniger: (davor: string) => `, weniger als davor (${davor})`,
    ohneMehr: (davor: string) => `, mehr als davor (${davor})`,
    ohneGleich: ', wie davor',
    alleMitQuelle: 'Jede Antwort nannte mindestens eine Quelle.',
  },
  tipp: {
    recherchen: (schnitt: string) => `${SO_RECHNET.rechercheTipp} Im Schnitt ${schnitt} je Tag.`,
    vorher: (von: string, bis: string) => `Vorzeitraum ${von} bis ${bis}`,
    vorherFuss: 'Gleich lang, direkt davor. Der Schnitt davor steht links in der Grafik.',
    aktiv: `${SO_RECHNET.aktivTipp} Die Grafik weiter unten zeigt, wie viele es je Tag waren.`,
    wochentag: (schnitt: string, tage: number, wochentag: string, mehrzahl: string) =>
      `Im Schnitt ${schnitt} Recherchen an ${tage} ${tage === 1 ? wochentag : mehrzahl}. In der Grafik hinterlegt.`,
    quelle: (antworten: string, alle: string) => `${antworten} von ${alle} Antworten nannten Treffer daraus.`,
    ohneQuelle: (antworten: string, alle: string) => `${antworten} von ${alle} Antworten nannten keine Quelle.`,
    imZeitraum: 'im Zeitraum', davor: 'davor', zeitraum: 'Zeitraum',
    kostenFuss: 'Summe der KI-Kosten, netto',
  },
} as const;

/** Profil-Nachbau F-25 Entwurf C (PF-GC-baustein-1): Bedienwörter der Ziel-Bausteine (ZielBausteine.tsx). Sätze der Seiten stehen in
 *  ZIEL_REGELN und ZIEL_PLATTFORM. */
export const ZIEL = {
  festlegen: 'Ziel festlegen',
  aendern: 'Ziel ändern',
  uebernehmen: 'Übernehmen',
  abbrechen: 'Abbrechen',
  entfernen: 'Ziel entfernen',
  keinZiel: 'Noch kein Ziel festgelegt.',
  beispiel: (wert: string) => `Zum Beispiel ${wert}.`,
  erreicht: (p: number) => `${p} % des Ziels erreicht`,
  skalaErreicht: (p: number) => `${p} % erreicht`,
  zielWert: (wert: string) => `Ziel ${wert}`,
  bereich: (min: string, max: string) => `Bitte eine ganze Zahl von ${min} bis ${max} eingeben.`,
  schritte: 'Was als Nächstes hilft',
  nichtsZuTun: 'Gerade gibt es nichts zu tun.',
  erledigt: 'erledigt',
  wochentage: ['Mo', 'Di', 'Mi', 'Do', 'Fr'] as const,
  woche: (n: number) => `${n}. Wo.`,
  schritteErledigt: (n: number, m: number) => `${n} von ${m} Schritten erledigt`,
} as const;

// ---- Profil-Nachbau F-25 Entwurf C (PF-GC-regeln-1; cockpit-grafiken-20261019\SCHNITTSTELLEN-C.md 3.2): die Wörter der Regeln des
// Firmen-Cockpits in ziel.ts – Zielblöcke je Seite, Ziel im Zeitraum mit Hochrechnung, Kurve, Wer mitmacht, gewonnene Zeit als
// Arbeitstage, Gründlichkeit, „Was als Nächstes hilft“ und die Schritte des Exports. Ziele gelten für die ganze Firma, nie je Person.
// Kein Betrag, kein fester Produktname. Teile mit führendem Leerzeichen oder Satzzeichen folgen einem Teil davor.
export const ZIEL_REGELN = {
  titel: { uebersicht: 'Ihr Ziel', person: 'Ziel: alle dabei', team: 'Ziel: Zahlen je Team', quellen: 'Ziel: Antworten mit Quelle',
    aufmerksamkeit: 'Ziel: alles in Ordnung', export: 'Fortschritt' },
  fuss: 'Das Ziel gilt für die ganze Firma, nie für einzelne Personen.',
  formular: { recherchen: 'Ziel: Recherchen je 30 Tage für die ganze Firma', quellen: 'Ziel: Antworten mit Quelle, in Prozent' },
  gespeichert: 'Das Ziel ist gespeichert. Die Änderung steht im Änderungsprotokoll.',
  entfernt: 'Das Ziel ist entfernt. Die Änderung steht im Änderungsprotokoll.',
  skala: {
    links: '0',
    erreicht: (p: number) => `${p} % erreicht`,
    ziel: (wert: string) => `Ziel ${wert}`,
  },
  festlegen: {
    text: 'Mit einem Ziel sehen Sie hier, wie weit Ihre Firma ist.',
    keinZiel: 'Noch kein Ziel festgelegt.',
    beispiel: (wert: string) => `Zum Beispiel ${wert}.`,
    recherchen: (wert: string) => `${wert} Recherchen je 30 Tage`,
    quellen: (p: number) => `${p} % der Antworten mit Quelle`,
    wer: 'Ziele setzen Besitzer und Administratoren der Firma.',
  },
  stand: {
    von: (ziel: string, eine: boolean) => `von ${ziel} ${eine ? 'Recherche' : 'Recherchen'}`,
    imMonat: (monat: string) => ` im ${monat}`,
    heute: ' heute',
    imZeitraum: (eine: boolean) => eine ? 'Recherche im Zeitraum' : 'Recherchen im Zeitraum',
  },
  satz: {
    keinZiel: 'Noch kein Ziel festgelegt.',
    ganzeFirma: 'Das Ziel gilt für die ganze Firma.',
    noch: 'Noch ',
    bisZiel: ' bis zum Ziel.',
    vorzeitraum: (p: number) => ` Im Vorzeitraum waren es ${p} %.`,
    gestern: (p: number) => ` Gestern waren es ${p} %.`,
    zuFrueh: ' Für eine Hochrechnung ist es noch zu früh.',
    tempo: (tag: number, monat: string) => `Bei diesem Tempo werden es bis ${tag}. ${monat} rund `,
    inReichweite: '. Das Ziel ist in Reichweite.',
    fehlen: (n: string) => `. Für das Ziel fehlen dann noch ${n}.`,
    erreicht: 'Ziel erreicht',
    uebertroffen: (ist: string, ziel: string) => `Ziel übertroffen: ${ist} statt ${ziel}`,
    davor: (p: number) => `, davor waren es ${p} %.`,
    davorKeine: ', davor gab es noch keine Recherchen.',
    gesternProzent: (p: number) => `, gestern waren es ${p} %.`,
    gesternKeine: ', gestern gab es keine Recherchen.',
    danach: '. ',
    punkt: '.',
  },
  kurve: {
    zusammen: (wort: string) => `${wort}, zusammengezählt`,
    jeWoche: (wort: string) => `${wort} je Woche`,
    jeMonat: (wort: string) => `${wort} je Monat`,
    zielWoche: (wert: string) => `Ziel ${wert} je Woche`,
    zielMonat: (wert: string) => `Ziel ${wert} je Monat`,
    tagVon: (i: number, k: number) => ` · Tag ${i} von ${k}`,
    bis: (tag: string) => `bis ${tag}`,
    hochrechnung: 'Hochrechnung',
    rund: (wert: string) => `rund ${wert}`,
    davorBis: (tag: string) => `davor bis ${tag}`,
    ziel: 'Ziel',
    fuss: (wort: string, tag: string) => `${wort} zusammengezählt seit ${tag}`,
  },
  mitmachen: {
    imZeitraum: 'im Zeitraum', heute: 'heute',
    alle: (n: string, wann: string) => `Alle ${n} Personen haben ${wann} gefragt`,
    einzige: (wann: string) => `Die einzige Person hat ${wann} gefragt`,
    einzigeNicht: (wann: string) => `Die einzige Person hat ${wann} nicht gefragt`,
    niemand: (wann: string) => `Niemand hat ${wann} gefragt`,
    von: (a: string, n: string, eine: boolean, wann: string) => `${a} von ${n} Personen ${eine ? 'hat' : 'haben'} ${wann} gefragt`,
    davor: (d: string) => `, davor ${d}.`,
    wieDavor: ', wie davor.',
    punkt: '.',
    label: (a: string, n: string, eine: boolean, einePerson: boolean) => `${a} von ${n} ${einePerson ? 'Person' : 'Personen'} ${eine ? 'hat' : 'haben'} gefragt`,
    an: (a: string) => `hat gefragt: ${a}`,
    aus: (n: string) => `ohne Frage: ${n}`,
    hinweis: 'Gefüllt: hat gefragt. Wer das ist, steht hier nie.',
  },
  zeit: {
    tage: (t: string) => ` geschätzt, das sind ${t} Arbeitstage zu 8 Stunden.`,
    wochen: (w: string) => ` geschätzt, das sind ${w} Arbeitswochen zu 40 Stunden.`,
    unterTag: ' geschätzt, weniger als ein Arbeitstag.',
    keine: 'Im Zeitraum gab es noch keine gewonnene Zeit.',
    labelTage: (dauer: string, t: string) => `${dauer}, das sind ${t} Arbeitstage zu 8 Stunden`,
    labelWochen: (dauer: string, w: string) => `${dauer}, das sind ${w} Arbeitswochen zu 40 Stunden`,
    labelUnterTag: (dauer: string) => `${dauer}, weniger als ein Arbeitstag`,
  },
  gruendlich: {
    satz: (n: number) => n === 0 ? 'Auf 10 Recherchen kommt keine Nachfrage' : n === 1 ? 'Auf 10 Recherchen kommt 1 Nachfrage' : `Auf 10 Recherchen kommen ${n} Nachfragen`,
    wieDavor: (jetzt: string, davor: string) => `, wie davor (${jetzt} statt ${davor} je Recherche).`,
    gleich: ', wie davor.',
    davor: (n: number) => `, davor ${n}.`,
    punkt: '.',
    keine: 'Im Zeitraum gab es keine Recherchen.',
    keineHeute: 'Heute gab es noch keine Recherchen.',
  },
  person: {
    von: (n: string, eine: boolean) => `von ${n} ${eine ? 'Person hat' : 'Personen haben'} gefragt`,
    noch: (f: string, eine: boolean) => `Noch ${f} ${eine ? 'Person' : 'Personen'} bis alle dabei sind.`,
    alle: 'Alle sind dabei.',
    davor: (d: string, n: string) => `Davor waren es ${d} von ${n}.`,
    fuss: 'Das Ziel gilt für die ganze Firma; wer fehlt, zeigt das Cockpit ohne Namen nie.',
    schnitt: (s: string) => `Im Schnitt ${s} Recherchen je aktive Person`,
    anTagen: (t: string, n: string) => `, an ${t} von ${n} Tagen`,
  },
  team: {
    vonTeam: (m: string, name: string) => `von ${m} Personen im Team „${name}“`,
    groesse: 'Teamgröße heute',
    noetig: (m: string) => `nötig: ${m} aktive`,
    schutzTeam: (produkt: string, m: string) => `Ohne Namen zeigt ${produkt} Zahlen je Team erst ab ${m} Personen mit Anfragen.`,
    darunter: (k: string, eine: boolean) => ` Mit ${k} ${eine ? 'Person' : 'Personen'} bleibt das Team darunter, auch wenn alle fragen.`,
    zuWenigAktiv: ' Im Zeitraum haben im Team zu wenige Personen gefragt.',
    vonGruppen: (g: string, eine: boolean) => `von ${g} ${eine ? 'Gruppe zeigt' : 'Gruppen zeigen'} Zahlen`,
    alleGruppen: (m: string) => `Alle Gruppen haben mindestens ${m} aktive Personen.`,
    schutzGruppe: (produkt: string, m: string) => `Ohne Namen zeigt ${produkt} Zahlen je Gruppe erst ab ${m} Personen mit Anfragen.`,
    mitNamen: 'Mit eingeschalteten Namen stehen überall Zahlen.',
    fuss: 'Gemessen wird die Teamgröße heute, nie wer wie viel fragt.',
  },
  quellen: {
    gross: (p: number) => `${p} %`,
    von: (n: string, eine: boolean) => eine ? `der ${n} Antwort nennt eine Quelle` : `der ${n} Antworten nennen eine Quelle`,
    keine: 'keine Antworten im Zeitraum',
    erreicht: 'erreicht',
    noch: (n: number) => `noch ${n} ${n === 1 ? 'Punkt' : 'Punkte'}`,
    ziel: (p: number) => `Ziel ${p} %`,
    davor: (p: number) => `Davor waren es ${p} %.`,
    ohne: (n: string, eine: boolean) => `${n} ${eine ? 'Antwort blieb' : 'Antworten blieben'} ohne Quelle.`,
  },
  aufmerksamkeit: {
    von: (p: number) => `von ${p} ${p === 1 ? 'Prüfung' : 'Prüfungen'} ohne Handlungsbedarf`,
    offen: (h: number) => `${h} ${h === 1 ? 'Hinweis' : 'Hinweise'} offen`,
    inOrdnung: 'alles in Ordnung',
    alleOk: 'Alle Prüfungen sind ohne Hinweis.',
    nurInaktiv: (n: number) => n === 1 ? 'Offen ist nur die Person, die seit 30 Tagen nicht gefragt hat.'
      : `Offen sind nur die ${n} Personen, die seit 30 Tagen nicht gefragt haben.`,
    nurGrenze: 'Offen sind nur die persönlichen Grenzen.',
    nurKontingent: 'Offen ist nur das Kontingent.',
    mehrere: (h: number) => `${h} Hinweise sind offen.`,
  },
  export: {
    folge: 'In drei Schritten zur Datei',
    unterzeile: 'nur Anzahlen und Prozent; der Download steht im Änderungsprotokoll',
    von: 'von 3 Schritten erledigt',
    waehlen: 'jetzt Datei wählen', laden: 'jetzt herunterladen', bereit: 'Datei bereit', fertig: 'fertig',
    zeitraum: 'Zeitraum gewählt',
    spanne: (von: string, bis: string, tage: number) => `${von} bis ${bis} · ${tage} ${tage === 1 ? 'Tag' : 'Tage'}`,
    datei: 'Datei wählen',
    ladenFirma: 'Mit Passwort herunterladen', ladenPlattform: 'Herunterladen',
    hinweisFirma: 'Ihr Passwort ist Pflicht; der Download steht im Änderungsprotokoll.',
    hinweisPlattform: 'Ohne Passwort; jeder Export steht im Betreiberprotokoll.',
    vorschauLeer: 'Wählen Sie in Schritt 2 eine Datei; hier erscheinen ihre ersten Zeilen.',
  },
  schritte: {
    mitglieder: 'Mitglieder ansehen', kontingent: 'Kontingent ansehen', quellen: 'Quellen ansehen', teams: 'Teams ansehen',
    zuPersonen: 'Zu „Nutzung je Person“',
    einfuehrung: 'Eine kurze Einführung im Team hilft oft.',
    termin: 'Ein guter Termin für eine Einführung.',
    inaktivStark: (n: number) => `${n} ${n === 1 ? 'Person' : 'Personen'}`,
    // PF-GC-zeitraum-1: die Zahl kommt aus dem gewählten Zeitraum („Wer mitmacht: ohne Frage“), nicht mehr aus „Aufmerksamkeit“.
    inaktivText: (n: number) => `${n === 1 ? 'hat' : 'haben'} im gewählten Zeitraum keine Frage gestellt. Eine kurze Einführung im Team hilft oft.`,
    keinKontingent: 'Kein Kontingent festgelegt.',
    keinKontingentText: 'Mit Kontingent zeigt das Cockpit, wie viel davon verbraucht ist, in Prozent.',
    quelleGefragt: (name: string, mehrzahl: boolean, p: number, davor: number) => `${name} ${mehrzahl ? 'sind' : 'ist'} gefragt: ${p} % statt ${davor} %.`,
    quelleText: 'So oft stützen sich Antworten jetzt darauf.',
    ruhig: (tag: string) => `${tag} ist es am ruhigsten`,
    ruhigSchnitt: (schnitt: string) => `(im Schnitt ${schnitt} Recherchen). Ein guter Termin für eine Einführung.`,
    nichts: (n: number) => `${n} ${n === 1 ? 'Person hat' : 'Personen haben'} im Zeitraum nichts gefragt.`,
    namenAus: 'Namen bleiben aus.',
    namenAusText: 'Einschalten geht nur mit Betriebsvereinbarung oder Zustimmung der Personen.',
    teamsPflegen: 'Teams pflegen:',
    teamsPflegenText: (m: number) => `Personen dem passenden Team zuordnen; ab ${m} aktiven Personen je Gruppe stehen hier Zahlen.`,
    teamsAnlegen: 'Teams anlegen:',
    teamsAnlegenText: (m: number) => `Mit Teams stehen hier Zahlen je Gruppe, ab ${m} aktiven Personen.`,
    namenEin: 'Oder Namen einschalten:',
    namenEinText: 'nur mit Betriebsvereinbarung oder Zustimmung, dann gelten die Grenzen nicht.',
    quelleKurz: (name: string, mehrzahl: boolean) => `${name} ${mehrzahl ? 'sind' : 'ist'} gefragt:`,
    quelleZahlen: (p: number, davor: number) => `${p} % statt ${davor} %. So oft stützen sich Antworten jetzt darauf.`,
    landSelten: (name: string, p: number) => `${name} kommt selten vor (${p} %).`,
    landNie: (name: string) => `${name} kam im Zeitraum nicht vor.`,
    landText: 'Wer Landesrecht braucht, nennt am besten das Bundesland in der Frage.',
    ohneQuelle: (p: number) => `Antworten ohne Quelle: ${p} %.`,
    zielErreicht: (z: number) => `Das Ziel von ${z} % ist erreicht.`,
    zielFehlt: (z: number, n: number) => `Für das Ziel von ${z} % ${n === 1 ? 'fehlt 1 Punkt' : `fehlen ${n} Punkte`}.`,
    einfuehrungAlle: 'Eine kurze Einführung für alle anbieten.',
    inaktivOhneNamen: (n: number) => `Ohne Namen sehen Sie nur, dass ${n} ${n === 1 ? 'Person' : 'Personen'} seit 30 Tagen nicht gefragt ${n === 1 ? 'hat' : 'haben'}, nicht wer.`,
    inaktivMitNamen: 'Wer seit 30 Tagen nicht gefragt hat, steht in der Liste.',
    grenzen: 'Persönliche Grenzen prüfen:',
    grenzenText: (n: number) => `${n} ${n === 1 ? 'Person hat' : 'Personen haben'} mindestens 80 % erreicht.`,
    kontingentText: (p: string, monat: string, inRecherchen?: boolean) => `${p}${inRecherchen ? ' der Recherchen' : ''} im ${monat} verwendet.`,
    festlegen: 'Kontingent festlegen,',
    festlegenText: 'dann warnt diese Seite rechtzeitig bei 80 %.',
  },
} as const;

/** Profil-Nachbau F-25 Entwurf C (PF-GC-seite-1; cockpit-grafiken-20261019/entwurf/vorschlag-c.html): Wörter der Firmen-Übersicht
 *  „Ziel und Fortschritt“ (FirmenCockpit.tsx Uebersicht). Sätze mit Zahlen, Titel, Fuß und Formular des Zielblocks stehen in ZIEL_REGELN
 *  (ziel.ts), Bedienwörter der Bausteine in ZIEL, Linienwörter in DIAGRAMM; hier steht nichts davon doppelt. Nur Anzahlen und Prozent;
 *  der Produktname kommt aus der Marke. */
export const UEBERSICHT_C = {
  gesetzt: (zahl: string) => `Ziel auf ${zahl} Recherchen je 30 Tage gesetzt.`,
  mitmachen: 'Wer mitmacht',
  zeit: 'Gewonnene Zeit',
  gruendlich: 'Wie gründlich gefragt wird',
  schutzTitel: (gruppe: string) => `Für „${gruppe}“ zeigen wir hier keine Zahlen`,
  schutzText: (produkt: string, mindestens: number) =>
    `Ohne Namen zeigt ${produkt} die Zahlen einer Gruppe erst ab ${mindestens} Personen mit Anfragen im Zeitraum. Hier waren es weniger. So bleibt niemand einzeln erkennbar.`,
  schutzKlein: 'Für die ganze Firma sehen Sie alle Zahlen wie gewohnt.',
  ganzeFirmaZeigen: 'Ganze Firma zeigen',
  // PF-GC-tag-1 (Vergleich, Empfehlung 2 und 3): Umschalter über der Hauptgrafik beider Übersichten (TagAnsicht.tsx); der erste Knopf heißt
  // nach der Einheit des Verlaufs. Titel der Säulen je Tag und die Linien „Schnitt …“, „davor …“; je Woche und Monat ZIEL_REGELN.kurve.
  ansicht: {
    gruppe: 'Ansicht der Grafik',
    je: { TAG: 'Je Tag', WOCHE: 'Je Woche', MONAT: 'Je Monat' },
    summe: 'Zusammengezählt',
    info: 'Je Tag zeigt, wann Ihr Team recherchiert. Zusammengezählt zeigt, wie weit Sie im Zeitraum sind.',
    titelTag: (wort: string) => `${wort} je Tag`,
    schnitt: (wert: string) => `Schnitt ${wert}`,
    davor: (wert: string) => `davor ${wert}`,
  },
} as const;

/** Profil-Nachbau F-25 Entwurf C (PF-GC-regeln-2): die Wörter der Regeln des Plattform-Cockpits (zielPlattform.ts). Beträge kommen
 *  fertig herein (Format der Seite); hier steht nie eine Währung, nie eine Person, kein fester Produktname. Die Sätze von „Antworten
 *  hilfreich“ stehen in QUELLEN_C (PF-GC-seite-3), „Ziel 3“ und „33 % erreicht“ in ZIEL. */
export const ZIEL_PLATTFORM = {
  // Ziel „aktive Firmen“ (AKTIVE_FIRMEN, Prozent der Firmen mit Zugang); ohne Ziel heißt der Block KENNZAHL.aktiveFirmen
  aktivTitelAlle: 'Ziel: alle Firmen aktiv',
  aktivTitelTeil: (p: number) => `Ziel: ${p} % der Firmen aktiv`,
  aktivVon: (m: number, a: number) => `von ${m} ${m === 1 ? 'Firma' : 'Firmen'} mit Zugang ${a === 1 ? 'hat' : 'haben'} gefragt`,
  alleAktiv: 'Alle Firmen mit Zugang haben im Zeitraum gefragt.',
  davor: (n: number) => `Davor waren es ${n}.`,
  // Kostendeckung (KOSTENDECKUNG: Umsatz geteilt durch KI-Kosten; „Marge positiv“ = 100 %); ohne Ziel heißt der Block KENNZAHL.marge
  deckungTitelPositiv: 'Ziel: Marge positiv',
  deckungTitelZiel: (p: number) => `Ziel: Umsatz deckt ${p} % der KI-Kosten`,
  margeImZeitraum: 'Marge im Zeitraum',
  deckt: (p: number) => `Umsatz deckt ${p} % der KI-Kosten`,
  geldSatz: (kosten: string, umsatz: string) => `KI-Kosten ${kosten} netto, Umsatz ${umsatz}.`,
  jeRecherche: (betrag: string) => `Im Schnitt ${betrag} je Recherche.`,
  ohneKosten: (umsatz: string) => `Im Zeitraum sind keine KI-Kosten angefallen; Umsatz ${umsatz}.`,
  kostenDavor: (betrag: string) => `Davor kostete die KI ${betrag}.`,
  deckungFuss: 'Kostendeckung: Umsatz geteilt durch KI-Kosten, beides netto.',
  // Nutzung je Firma
  firmaUnter: (tarif: string, recherchen: string, trend: string) => `${tarif} · ${recherchen} Recherchen · Trend ${trend}`,
  plaetze: (belegt: string, gesamt: string) => `Plätze ${belegt} von ${gesamt}`,
  plaetzeOhne: (belegt: string) => `Plätze ${belegt} (ohne Grenze)`,
  geldZeile: (umsatz: string, kosten: string, deckung: number | null) => `Umsatz ${umsatz} · Kosten ${kosten}${deckung === null ? '' : ` · deckt ${deckung} %`}`,
  einheiten: (a: number, n: number) => `${a} von ${n} ${n === 1 ? 'Firma' : 'Firmen'} mit Zugang ${a === 1 ? 'hat' : 'haben'} gefragt`,
  legendeAn: (n: number) => `hat gefragt: ${n}`,
  legendeAus: (n: number) => `ohne Frage: ${n}`,
  schritt: {
    zahlung: 'Zahlung überfällig.', zahlungOhneVertrag: 'Zahlung überfällig, ohne Vertrag.', nichts: 'Hat nichts gefragt.',
    ohneUmsatz: (produkt: string) => `Nutzt ${produkt}, ohne Umsatz im Zeitraum.`, kostenUeber: 'KI-Kosten über dem Umsatz.',
    sinkt: (trend: string) => `Nutzung sinkt deutlich (${trend}).`, plaetzeVoll: 'Fast alle Plätze belegt.', imPlan: 'Alles im Plan.',
  },
  link: { abrechnung: 'Zur Kundenabrechnung', abrechnungPruefen: 'Abrechnung prüfen', kontakt: 'Kontakt aufnehmen', tarif: 'Tarif prüfen',
    plaetze: 'Mehr Plätze anbieten', firma: 'Firma ansehen', firmen: 'Zu „Nutzung je Firma“' },
  // Übersicht: Was als Nächstes hilft
  umsatzPruefen: 'Umsatz prüfen:',
  ohneUmsatzEine: (name: string, plaetze: string | null, produkt: string) =>
    `${name} nutzt ${plaetze === null ? produkt : `${plaetze} Plätzen`}, im Zeitraum ist aber kein Umsatz verbucht.`,
  ohneUmsatzMehrere: (n: number, produkt: string) => `${n} Firmen nutzen ${produkt}, im Zeitraum ist aber kein Umsatz verbucht.`,
  zahlungEine: (name: string, ohneVertrag: boolean) => `„${name}“ ist mit der Zahlung überfällig${ohneVertrag ? ',' : '.'}`,
  ohneVertrag: 'ohne Vertrag.',
  zahlungMehrere: (n: number) => `${n} Firmen sind mit der Zahlung überfällig.`,
  still: (k: number) => `${k} ${k === 1 ? 'Firma' : 'Firmen'} ohne Frage:`,
  stillText: 'kurz nachfragen, ob alles funktioniert.',
  // Nutzung je Tarif
  tarifTitel: (name: string) => `Tarif ${name}`,
  tarifDeckt: 'der KI-Kosten deckt der Umsatz',
  tarifOhneKosten: 'keine KI-Kosten im Zeitraum',
  marge: (betrag: string) => `Marge ${betrag}`,
  fehlen: (betrag: string) => `fehlen ${betrag}`,
  jePlatz: (x: string, p: number) => `${x} Recherchen je belegtem Platz (${p} ${p === 1 ? 'Platz' : 'Plätze'}).`,
  keinPlatz: 'In diesem Tarif ist kein Platz belegt.',
  tarifOhneZiel: 'Das Ziel für die Kostendeckung legen Sie in der Übersicht fest.',
  // Aufmerksamkeit: die vier Prüfungen
  pruefTitel: 'Ziel: alles in Ordnung',
  pruefVon: 'von 4 Prüfungen ohne Handlungsbedarf',
  allesInOrdnung: 'alles in Ordnung',
  offen: (n: number) => `${n} ${n === 1 ? 'Hinweis' : 'Hinweise'} offen`,
  offenEine: (name: string) => `Offen: „${name}“`,
  offenMehrere: (teile: string[]) => `Offen: ${teile.join('; ')}.`,
  grundZahlungOhneVertrag: ' ist mit der Zahlung überfällig, ohne Vertrag.',
  pruefung: (titel: string, n: number) => `${titel} (${n})`,
  keine: { zahlung: 'Keine Firma.', kontingent: 'Keine Firma über 80 %.', inaktiv: 'Keine zahlende Firma still.', testphase: 'Keine Testphase endet in 7 Tagen.' },
  namen: (namen: string[], weitere: number) => `${namen.join(', ')}${weitere > 0 ? ` und ${weitere} weitere` : ''}`,
  ohneVertragName: (name: string) => `${name} (ohne Vertrag)`,
  kontingentName: (name: string, p: string, inRecherchen?: boolean) => `${name} (${p}${inRecherchen ? ' der Recherchen' : ''})`,
  testphaseName: (name: string, tag: string) => `${name} (endet am ${tag})`,
  zahlungKlaeren: 'Zahlung klären:',
  seitHeute: 'seit heute',
  seitTag: (tag: string) => `seit ${tag}`,
  zahlungSchritt: (name: string, seit: string | null, ohneVertrag: boolean) =>
    `„${name}“ ist ${seit === null ? '' : `${seit} `}überfällig${ohneVertrag ? ' und hat keinen Vertrag hinterlegt' : ''}.`,
  kontingentAnsprechen: 'Kontingent ansprechen:',
  kontingentMehrere: (n: number) => `${n} Firmen haben ihr Kontingent fast oder ganz verwendet.`,
  testphaseBegleiten: 'Testphase begleiten:',
  testphaseMehrere: (n: number) => `${n} Testphasen enden in den nächsten 7 Tagen.`,
  stilleAnsprechen: 'Kontakt aufnehmen:',
  inaktivMehrere: (n: number) => `${n} zahlende Firmen haben seit 30 Tagen keine Frage gestellt.`,
} as const;

/** Profil-Nachbau F-25 Entwurf C (PF-GC-seite-2; cockpit-grafiken-20261019/entwurf/c-plattform-uebersicht.html): Wörter der
 *  Plattform-Übersicht „Ziel und Fortschritt“ (PlattformCockpit.tsx Uebersicht). Sätze mit Zahlen stehen in ZIEL_PLATTFORM
 *  (zielPlattform.ts); Beträge kommen fertig über netMoney herein. Kein Währungswort in diesem Block (Euro-Ratsche).
 *  Titel, „von … Firmen mit Zugang“, „Marge im Zeitraum“ und „Umsatz deckt … %“ stehen nur in ZIEL_PLATTFORM (D-13). */
export const PLATTFORM_C = {
  nurAlle: 'Die Ziele gelten für alle Firmen.',
  formFirmen: 'Ziel: aktive Firmen in Prozent der Firmen mit Zugang',
  formDeckung: 'Ziel: Umsatz in Prozent der KI-Kosten (100 % = Marge positiv)',
  beispielFirmen: '100 % der Firmen mit Zugang',
  beispielDeckung: '100 %, also Marge positiv',
  gesetzt: 'Das Ziel ist gesetzt.',
  entfernt: 'Das Ziel ist entfernt.',
  kurveGeld: 'KI-Kosten und Umsatz, zusammengezählt',
  kurveUnter: 'netto, seit Beginn des Zeitraums',
  kurve: { recherchen: 'Recherchen, zusammengezählt', nachfragen: 'Nachfragen, zusammengezählt', beide: 'Fragen, zusammengezählt' },
  /** Wort im Fuß des Tooltips ohne Euro („Recherchen zusammengezählt seit …“, ZIEL_REGELN.kurve.fuss); ziel.ts gibt es nicht heraus. */
  wort: { recherchen: 'Recherchen', nachfragen: 'Nachfragen', beide: 'Fragen' },
  kostenBisHier: 'KI-Kosten bis hier',
  umsatzBisHier: 'Umsatz bis hier',
  tippFuss: 'netto, zusammengezählt',
  spalteUmsatz: 'Umsatz (netto)',
  tarif: 'Tarif', alleTarife: 'Alle Tarife',
  /** PF-GC-signal-1: Wort neben einer negativen Marge (Zielblock, Tarif-Tabelle), damit die Signalfarbe nicht allein trägt. */
  unterNull: 'unter null',
  /** PF-GC-tag-1: Info-Symbol am Umschalter der Recherchen-Grafik (Knöpfe in UEBERSICHT_C.ansicht); die Plattform hat kein „Ihr Team“. */
  ansichtInfo: 'Je Tag zeigt, wann die Firmen recherchieren. Zusammengezählt zeigt, wie weit sie im Zeitraum sind.',
} as const;

/** Profil-Nachbau F-25 Entwurf C (PF-GC-seite-3; c-quellen.html, c-plattform-quellen.html): Wörter des Teils „Quellen“ beider Cockpits.
 *  Zielblock „Antworten mit Quelle“ und die Schritte kommen aus ziel.ts (ZIEL_REGELN). Kein Betrag, keine Person, kein fester Produktname. */
export const QUELLEN_C = {
  /** Skala „Ziel … %“ im Block „Antworten hilfreich“. */
  zielWert: (p: number) => `Ziel ${p} %`,
  fussPlattform: 'Das Ziel gilt für alle Firmen zusammen.',
  woher: 'Woher die Antworten kamen',
  woherUnter: 'Balken: Anteil · in Klammern: Zahl der Antworten · Strich: davor',
  woherUnterOhneVergleich: 'Balken: Anteil · in Klammern: Zahl der Antworten',
  hinweis: 'Mehrfachnennung möglich. Was gesucht wurde, steht hier nie.',
  auswahl: 'Quelle', alle: 'Alle Quellen',
  /** Gleich QUELLEN_NAMEN am Server (backend/src/administration/cockpit/quellen.ts:13-16). */
  arten: { BUNDESRECHT: 'Bundesrecht', LANDESRECHT: 'Landesrecht', JUDIKATUR: 'Judikatur', DOKUMENTE: 'Kollektivverträge und Dokumente',
    WEB: 'Web', RIS_SONSTIGE: 'Sonstige RIS-Dokumente' },
  grafik: { TAG: 'Antworten je Tag', WOCHE: 'Antworten je Woche', MONAT: 'Antworten je Monat' },
  grafikQuelle: (quelle: string, je: string) => `Antworten mit Treffern aus ${quelle} ${je}`,
  je: { TAG: 'je Tag', WOCHE: 'je Woche', MONAT: 'je Monat' },
  mitQuelle: 'Mit Quelle', ohneQuelle: 'Ohne Quelle', antworten: 'Antworten',
  hilfreichTitel: 'Ziel: Antworten hilfreich',
  hilfreichKeine: (wochen: number) => `noch keine Bewertungen in den letzten ${wochen} Wochen`,
  hilfreichVon: (zahl: string, eine: boolean, wochen: number) => `hilfreich, aus ${zahl} ${eine ? 'Bewertung' : 'Bewertungen'} in ${wochen} Wochen`,
  hilfreichSobald: 'Sobald Bewertungen da sind, zeigt der Balken den Anteil „hilfreich“.',
  hilfreichRegel: (min: number, anteil: string, anzahl: number, tage: string) =>
    `Unter ${min} Bewertungen je Woche, Modell und Weg steht kein Anteil; eine Warnung kommt unter ${anteil} bei mindestens ${anzahl} Bewertungen in ${tage}.`,
  tage: (n: number) => n === 1 ? 'einem Tag' : `${n} Tagen`,
  gezaehltSeit: (tag: string) => `gezählt seit ${tag}`,
  gezaehltSeitSatz: (tag: string) => `Gezählt wird seit ${tag}.`,
  intern: (n: number) => `Bewertungen aus der internen Organisation im Zeitraum: ${n} (nicht gezählt).`,
} as const;

/** Profil-Nachbau F-25 (PF-GC-kennzahlen-1; Benny 19.10.2026: „… kasten oben mit infos auf einem blick …“): die Kennzahlenleiste oben
 *  in beiden Übersichten (kennzahlenLeiste.ts). Der Vergleich nimmt die Wörter von STIL (zumVorzeitraum, neu); Beträge setzt die Seite
 *  der Plattform als fertigen Text ein, hier steht keiner. */
export const KENNZAHLEN_C = {
  leiste: 'Kennzahlen auf einen Blick',
  recherchen: 'Recherchen', recherchenHeute: 'Recherchen heute', aktivePersonen: 'Aktive Personen', aktivePersonenHeute: 'Aktive Personen heute',
  nachfragen: 'Nachfragen', jeTag: 'Recherchen je Tag',
  aktiveFirmen: 'Aktive Firmen', kostenJeRecherche: 'Kosten je Recherche',
  imZeitraum: 'im Zeitraum', inLaufenden: 'in laufenden Recherchen', imSchnitt: 'im Schnitt',
  /** „heute bis 16:30“ (österreichische Zeit). */
  heuteBis: (uhrzeit: string) => `heute bis ${uhrzeit}`,
  von: (anzahl: string) => `von ${anzahl}`,
  /** „von 63 (68 %)“; anteil kommt fertig mit geschütztem Leerzeichen. */
  vonProzent: (anzahl: string, anteil: string) => `von ${anzahl} (${anteil})`,
  // PF-GC-kosten-1 (Benny 19.10.: „klar trennen gesamtkosten heute kosten auch so mit anzeige felder“): die zweite Leiste „Kosten“ der
  // Plattform und „Kontingent“ der Firma (nur Prozent); „Vom Kontingent verwendet“ und „KI-Kosten“ stehen nicht mehr in der Kennzahlenleiste.
  kostenTitel: 'Kosten', kostenHinweis: 'alle Beträge netto', gesamtkosten: 'Gesamtkosten', kostenHeute: 'Kosten heute', umsatz: KENNZAHL.umsatz,
  /** „Marge {Betrag}“; den Betrag setzt die Seite der Plattform ein. */
  marge: (betrag: string) => `Marge ${betrag}`,
  /** PF-GC-signal-1: negative Marge mit dem Wort „unter null“; die Unterzeile steht dann in der Signalfarbe. */
  margeUnterNull: (betrag: string) => `Marge ${PLATTFORM_C.unterNull}: ${betrag}`,
  // PF-GC-zeitraum-1 (Benny 20.10.: „… dass auf dieser Seite alle diagramme sich dementsprechend anpassen und auch alle zahlen“): die
  // erste Zelle „Kontingent“ folgt dem Zeitraum (Kontingent anteilig je Tag, Regel im Info-Symbol SO_RECHNET.kontingentTipp).
  kontingentTitel: 'Kontingent', kontingentTitelRecherchen: 'Kontingent in Recherchen', verbrauchtImZeitraum: 'Verbraucht im Zeitraum', anteiligJeTag: 'Kontingent anteilig je Tag',
  heuteVerbraucht: 'Heute verbraucht', reichtBis: 'Reicht bis',
  imPlan: 'im Plan', knapp: 'knapp',
  reichtBisTipp: 'Hochrechnung bei gleichem Verbrauch wie in den letzten 30 Tagen.',
  // PF-GC-zeitraum-1: liegt heute nicht im Zeitraum, stehen statt der Zellen „… heute“ die des letzten Tags („30.09.“, format.ts tagKurz).
  recherchenAm: (tag: string) => `Recherchen am ${tag}`, aktivePersonenAm: (tag: string) => `Aktive Personen am ${tag}`,
  kostenAm: (tag: string) => `Kosten am ${tag}`, verbrauchtAm: (tag: string) => `Verbraucht am ${tag}`,
  letzterTag: 'letzter Tag im Zeitraum',
} as const;
